import store from '../reducers/store'
import { postMessageToNativeApp } from '../utils/utils'
import { nativeMessageTypes } from '../constants/nativeMessageTypes'
import { getDailyBeatPreference, getUser } from '../requests/studentRequests'
import { loadUser } from '../reducers/userSlice'

export const pullUserFromServer = async (): Promise<any> => {
  const { dispatch } = store
  const userData = await getUser()
  const dailyBeatsPreference = await getDailyBeatPreference()
  dispatch(loadUser({
    id: userData.id,
    firstName: userData.firstName,
    lastName: userData.lastName,
    emailAddress: userData.emailAddress,
    role: userData.role,
    validated: userData.validated,
    deleted: userData.deleted,
    schoolId: userData.schoolId,
    districtId: userData.districtId,
    publicId: userData.publicId,
    canManageAdmins: userData.canManageAdmins,
    mustAcceptTerms: userData.mustAcceptTerms,
    summaryOfTermsUpdates: userData.summaryOfTermsUpdates,
    completedTeacherOrientation: userData.completedTeacherOrientation,
    dismissedStudentViewCallout: userData.dismissedStudentViewCallout,
    seenWelcomeToStudentView: userData.seenWelcomeToStudentView,
    coursePoints: userData.classrooms[0]?.coursePoints || 0,
    mheCoursePoints: userData.classrooms[0]?.mheCoursePoints || 0,
    totalCoursePoints: userData.classrooms[0]?.totalCoursePoints || 100,
    pointsPerLessonCompletion: userData.pointsPerLessonCompletion,
    pointsPerDailyBeatCompletion: userData.pointsPerDailyBeatCompletion,
    colorSchemePreference: userData.colorSchemePreference,
    dailyBeatsPreference,
    teacherVerificationStatus: userData.teacherVerificationStatus,
    classroomId: userData.classrooms[0]?.classroomId || 0,
    completedStudentOrientation: userData.completedStudentOrientation,
    seenFocusSeshPreSetupOrientation: userData.seenFocusSeshPreSetupOrientation,
    seenFocusSeshPreSeshOrientation: userData.seenFocusSeshPreSeshOrientation,
    seenFocusSeshPreSeshOrientationStatus: userData.seenFocusSeshPreSeshOrientationStatus,
    seenClassLinkingTeacherInfo: userData.seenClassLinkingTeacherInfo,
    showVoiceGuidanceReturningUserDialog: userData.showVoiceGuidanceReturningUserDialog,
    voiceGuidanceCurriculumIndex: userData.voiceGuidanceCurriculumIndex,
    showVoiceGuidanceCaptions: userData.showVoiceGuidanceCaptions,
    seenDisableVoiceGuidancePopUp: userData.seenDisableVoiceGuidancePopUp,
    showCompletionGraph: userData.showCompletionGraph,
    recentSoundtracks: userData.recentSoundtracks,
    dismissedFocusCoachConfidentialityMessage: userData.dismissedFocusCoachConfidentialityMessage,
    dismissedPiPFeatureTag: userData.dismissedPiPFeatureTag,
    dismissedPersonalReflectionConfidentialityMessage: userData.dismissedPersonalReflectionConfidentialityMessage,
    autoCheckInsFrequencyPreferenceLevel: userData.autoCheckInsFrequencyPreferenceLevel,
    showAutoCheckInsPostSeshFeedback: userData.showAutoCheckInsPostSeshFeedback,
    seenAgeAndConsentDisclaimerStatus: userData.seenAgeAndConsentDisclaimerStatus,
    lastSeenStudentInterfaceVersion: userData.lastSeenStudentInterfaceVersion,
    seenImportantInfoAboutNewClass: userData.seenImportantInfoAboutNewClass,
    seenTenDayCourseTabInfo: userData.seenTenDayCourseTabInfo,
    dismissedArchivingClassesCallout: userData.dismissedArchivingClassesCallout,
    showAutoArchivedClassesNotice: userData.showAutoArchivedClassesNotice,
    dismissedAISupportFeatureTag: userData.dismissedAISupportFeatureTag,
    showCourseProgressResetNotice: userData.showCourseProgressResetNotice,
    experimentalFeaturesEnabled: userData.experimentalFeaturesEnabled,
    focusStreakCount: userData.focusStreakCount,
    lessonNarrationEnabled: userData.lessonNarrationEnabled,
    lessonSoundtrackEnabled: userData.lessonSoundtrackEnabled,
    // Last Custom Focus Sesh Settings
    lastCustomFocusSeshWasTimed: userData.lastCustomFocusSeshWasTimed,
    lastCustomFocusSeshDuration: userData.lastCustomFocusSeshDuration,
    lastCustomFocusSeshWasNoCheckIns: userData.lastCustomFocusSeshWasNoCheckIns,
    lastCustomFocusSeshWasAutoCheckIns: userData.lastCustomFocusSeshWasAutoCheckIns,
    lastCustomFocusSeshCheckInTiming: userData.lastCustomFocusSeshCheckInTiming,
    lastCustomFocusSeshCheckInSound: userData.lastCustomFocusSeshCheckInSound,
    lastCustomFocusSeshVoiceGuidance: userData.lastCustomFocusSeshVoiceGuidance,
    lastCustomFocusSeshSoundtrack: userData.lastCustomFocusSeshSoundtrack,
  }))
  postMessageToNativeApp({
    type: nativeMessageTypes.reloadUser
  })
  return userData

}
